import router from './index'
import store from '@/store'
import { getToken } from '@/utils/auth'

const whiteList = ['/login', '/loading', '/403', '/404']

router.beforeEach(async (to, from, next) => {
  const token = getToken()

  // 无 token：白名单放行，其余跳登录
  if (!token) {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next('/login')
    }
    return
  }

  // 已登录访问 /login，跳转首页
  if (to.path === '/login') {
    next('/loading')
    return
  }

  // 白名单路由直接放行
  if (whiteList.includes(to.path)) {
    next()
    return
  }

  // 已有用户信息，直接放行
  if (store.state.user.userInfo) {
    next()
    return
  }

  // 页面刷新后 Vuex 丢失，重新拉取用户信息并生成菜单
  try {
    const userInfo = await store.dispatch('user/refreshUserInfo')
    store.dispatch('permission/generateMenu', userInfo)
    next()
  } catch (error) {
    store.dispatch('user/logout')
    next('/login')
  }
})
